import { Routes } from '@angular/router';
import { MainLayoutComponent } from './main-layout.component';
import { AuthGuard } from 'src/app/core/auth-guard/auth.guard';
import { RolesGuard } from 'src/app/core/roles/roles.guard';
import { UserGuard } from 'src/app/core/user-guard/user-guard.guard';
const ɵ0 = () => import("./../../main/b2-b/b2-b.module.ngfactory").then(m => m.B2BModuleNgFactory), ɵ1 = () => import("./../../main/e-sign/e-sign.module.ngfactory").then(m => m.ESignModuleNgFactory), ɵ2 = () => import("./../../main/dispatch-sheet/dispatch-sheet.module.ngfactory").then(m => m.DispatchSheetModuleNgFactory), ɵ3 = () => import("./../../main/mercury-credit-card/mercury-credit-card.module.ngfactory").then(m => m.MercuryCreditCardModuleNgFactory), ɵ4 = {
    action: 'redirect',
    rules: [
        { role: 'fronter', view: 'fronter', pathModule: 'dashboard' },
        { role: 'sales_rep', view: 'sales_rep', pathModule: 'dashboard' },
        {
            role: 'sales_manager',
            view: 'sales_rep',
            pathModule: 'dashboard'
        },
        { role: 'super_admin', view: '', pathModule: 'dashboard' },
        { role: 'dispatcher', view: 'dispatcher', pathModule: 'dashboard' },
        { role: 'dispatcher_manager', view: 'dispatcher', pathModule: 'dashboard' },
        { role: 'track_trace', view: '', pathModule: 'orders' },
        { role: 'account_payable', view: '', pathModule: 'orders' },
        { role: 'account_receivable', view: '', pathModule: 'orders' },
        { role: 'carrier_relations', view: '', pathModule: 'orders' },
        { role: 'data_entry', view: '', pathModule: 'orders' },
        { role: 'quality_assurance', view: '', pathModule: 'orders' },
        { role: 'carrier_sales', view: '', pathModule: 'orders' }
    ]
}, ɵ5 = () => import("./../../main/dashboard/dashboard.module.ngfactory").then(m => m.DashboardModuleNgFactory), ɵ6 = () => import("./../../main/quotes/quotes.module.ngfactory").then(m => m.QuotesModuleNgFactory), ɵ7 = () => import("./../../main/orders/orders.module.ngfactory").then(m => m.OrdersModuleNgFactory), ɵ8 = () => import("./../../main/orders/orders.module.ngfactory").then(m => m.OrdersModuleNgFactory), ɵ9 = {
    // roles: ['super_admin'],
    roleLoaded: 'account_payable'
}, ɵ10 = () => import("./../../main/orders-management/orders-management.module.ngfactory").then(m => m.OrdersManagementModuleNgFactory), ɵ11 = () => import("./../../main/settings/settings.module.ngfactory").then(m => m.SettingsModuleNgFactory), ɵ12 = () => import("./../../main/leads/leads.module.ngfactory").then(m => m.LeadsModuleNgFactory), ɵ13 = () => import("./../../main/companies/companies.module.ngfactory").then(m => m.CompaniesModuleNgFactory), ɵ14 = () => import("./../../main/carriers/carriers.module.ngfactory").then(m => m.CarriersModuleNgFactory), ɵ15 = () => import("./../../main/users/users.module.ngfactory").then(m => m.UsersModuleNgFactory), ɵ16 = () => import("./../../main/tiers/tiers.module.ngfactory").then(m => m.TiersModuleNgFactory);
const routes = [
    {
        path: '',
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: 'B2B',
        loadChildren: ɵ0
    },
    {
        path: 'esign',
        loadChildren: ɵ1
    },
    {
        path: 'dispatch-sheet',
        loadChildren: ɵ2
    },
    {
        path: 'mercury',
        loadChildren: ɵ3
    },
    {
        path: 'main',
        component: MainLayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                data: ɵ4,
                canActivate: [RolesGuard, UserGuard],
                redirectTo: '',
                pathMatch: 'full'
            },
            {
                path: 'dashboard',
                loadChildren: ɵ5,
                canActivate: [UserGuard]
            },
            {
                path: 'quotes',
                loadChildren: ɵ6,
                canActivate: [RolesGuard]
                // data: {
                //   roles: ['sales_rep', 'sales_manager', 'super_admin']
                // }
            },
            {
                path: 'orders',
                loadChildren: ɵ7,
                canActivate: [RolesGuard]
                // data: {
                //   roles: [
                //     'dispatcher',
                //     'track_trace',
                //     'sales_rep',
                //     'sales_manager',
                //     'account_receivable',
                //     'account_payable',
                //     'carrier_relations',
                //     'super_admin',
                //     'data_entry',
                //     'quality_assurance'
                //   ]
                // }
            },
            {
                path: 'payments',
                loadChildren: ɵ8,
                canActivate: [RolesGuard],
                data: ɵ9
            },
            {
                path: 'order-management',
                loadChildren: ɵ10,
                canActivate: [RolesGuard]
                // data: {
                //   roles: [
                //     'sales_rep',
                //     'sales_manager',
                //     'super_admin',
                //     'data_entry',
                //     'dispatcher',
                //     'quality_assurance',
                //     'carrier_relations',
                //     'account_payable'
                //   ]
                // }
            },
            {
                path: 'settings',
                loadChildren: ɵ11
            },
            {
                path: 'leads',
                loadChildren: ɵ12,
                canActivate: [RolesGuard]
                // data: {
                //   roles: ['fronter', 'sales_rep', 'sales_manager', 'super_admin']
                // }
            },
            {
                path: 'companies',
                loadChildren: ɵ13,
                canActivate: [RolesGuard]
                // data: {
                //   roles: [
                //     'sales_rep',
                //     'sales_manager',
                //     'super_admin',
                //     'account_receivable'
                //   ]
                // }
            },
            {
                path: 'carriers',
                loadChildren: ɵ14,
                canActivate: [RolesGuard]
                // data: {
                //   roles: [
                //     'dispatcher',
                //     'account_payable',
                //     'sales_rep',
                //     'sales_manager',
                //     'super_admin',
                //     'carrier_sales'
                //   ]
                // }
            },
            {
                path: 'users',
                loadChildren: ɵ15,
                canActivate: [RolesGuard]
                // data: { roles: ['super_admin'] }
            },
            {
                path: 'tiers',
                loadChildren: ɵ16
            }
        ]
    }
];
export class MainRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16 };
